import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, MailQuestion, LogOut } from "lucide-react";

function NoTenantScreen() {
  const { user, logout } = useAuth();
  return (
    <div className="flex h-screen items-center justify-center bg-[#F7F7F8] px-6" data-testid="no-tenant-screen">
      <div className="max-w-md w-full bg-white border border-[#E4E4E7] rounded-sm p-8 text-center">
        <div className="h-12 w-12 rounded-sm bg-[#0055FF]/10 grid place-items-center mx-auto">
          <MailQuestion className="h-6 w-6 text-[#0055FF]" />
        </div>
        <h1 className="mt-4 font-heading font-bold text-lg text-[#09090B]">
          Tu cuenta todavía no está asociada a ninguna empresa
        </h1>
        <p className="mt-2 text-sm text-[#71717A]">
          Iniciaste sesión como <span className="font-medium text-[#09090B]" data-testid="no-tenant-email">{user?.email}</span>.
          Contactá al administrador para que te dé de alta en el tenant correspondiente.
        </p>
        <button
          data-testid="no-tenant-logout-button"
          onClick={logout}
          className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-[#EF4444] hover:underline"
        >
          <LogOut className="h-4 w-4" /> Cerrar sesión y probar con otra cuenta
        </button>
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children }) {
  const { loading, user, tenants } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-[#0055FF]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // El operador de la plataforma puede no tener membership en ningún tenant
  // -- necesita entrar de todas formas a /dashboard/clients (Prompt 27).
  if (user.is_platform_operator) return children;
  if (!tenants || tenants.length === 0) return <NoTenantScreen />;
  return children;
}
